import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Login from '../views/Login/Login.vue'
import Verify from '../views/Verify/Verify.vue'
import Home from '../views/Home/Home.vue'
import Role from '../views/Role/Role.vue'
import RoleEdit from '../views/RoleEdit/RoleEdit.vue'
import User from '../views/User/User.vue'
import UserEdit from '../views/UserEdit/UserEdit.vue'
import UserProfile from '../views/UserProfile/UserProfile.vue'
import Category from '../views/Category/Category.vue'
import Source from '../views/Source/Source.vue'
import TargetGroup from '../views/TargetGroup/TargetGroup.vue'
import TicketList from '../views/TicketList/TicketList.vue'
import Reference from '../views/Reference/Reference.vue'
import Customer from '../views/Customer/Customer.vue'
import Client from '../views/Client/Client.vue'
import ClientEdit from '../views/ClientEdit/ClientEdit.vue'
import CustomerEdit from '../views/CustomerEdit/CustomerEdit.vue'
import LocationEdit from '../views/LocationEdit/LocationEdit.vue'
import ContactEdit from '../views/ContactEdit/ContactEdit.vue'
import Question from '../views/Question/Question.vue'
import Questionnaire from '../views/Questionnaire/Questionnaire.vue'
import QuestionnaireAudit from '../views/QuestionnaireAudit/QuestionnaireAudit.vue'
import QuestionnaireEdit from '../views/QuestionnaireEdit/QuestionnaireEdit.vue'
import QuestionnaireDone from '../views/QuestionnaireDone/QuestionnaireDone.vue'
import QuestionnaireAppeal from '../views/QuestionnaireAppeal/QuestionnaireAppeal.vue'
import Test from '../views/Test/Test.vue'
import TestEdit from '../views/TestEdit/TestEdit.vue'
import PasswordReset from '../views/PasswordReset/PasswordReset.vue'

const routes: Array<RouteRecordRaw> = 
[
    {
        path: '/',
        name: 'home',
        component: Home
    },
    {
        path: '/login',
        name: 'login',
        component: Login
    },
    {
        path: '/verify',
        redirect: '/verify/_',
    },
    {
        path: '/verify/:token',
        name: 'verify',
        component: Verify
    },
    {
        path: '/user',
        name: 'user',
        component: User
    },
    {
        path: '/user/:userid',
        name: 'user-edit',
        component: UserEdit
    },
    {
        path: '/role',
        name: 'role',
        component: Role
    },
    {
        path: '/role/:roleid',
        name: 'role-edit',
        component: RoleEdit
    },
    {
        path: '/category',
        name: 'category',
        component: Category
    },
    {
        path: '/targetgroup',
        name: 'targetgroup',
        component: TargetGroup
    },
    {
        path: '/ticketlist',
        name: 'ticketlist',
        component: TicketList
    },
    {
        path: '/reference',
        name: 'reference',
        component: Reference 
    },
    {
        path: '/customer',
        name: 'customer',
        component: Customer
    },
    {
        path: '/customer/:customerid',
        name: 'customer-edit',
        component: CustomerEdit
    },
    {
        path: '/customer/:customerid/location/:locationid',
        name: 'location-edit',
        component: LocationEdit
    },
    {
        path: '/customer/:customerid/contact/:contactid',
        name: 'contact-edit',
        component: ContactEdit
    },
    {
        path: '/client',
        name: 'client',
        component: Client
    },
    {
        path: '/client/:clientid',
        name: 'client-edit',
        component: ClientEdit
    },
    {
        path: '/question',
        name: 'question',
        component: Question
    },
    {
        path: '/question/:questionid',
        name: 'question-edit',
        component: Question
    },
    {
        path: '/question/:questionid/:optionid',
        name: 'question-edit-option',
        component: Question
    },
    {
        path: '/questionnaire/:testid/:step/:substep',
        name: 'questionnaire',
        component: Questionnaire
    },
    {
        path: '/questionnaire/:testid/audit/:step/:substep',
        name: 'questionnaire-audit',
        component: QuestionnaireAudit
    },
    {
        path: '/questionnaire/:testid/edit',
        name: 'questionnaire-edit',
        component: QuestionnaireEdit
    },
    {
        path: '/questionnaire/:testid/done/:step/:substep',
        name: 'questionnaire-done',
        component: QuestionnaireDone
    },
    {
        path: '/questionnaire/:testid/appeal',
        name: 'questionnaire-appeal',
        component: QuestionnaireAppeal
    },
    {
        path: '/test',
        name: 'test',
        component: Test
    },
    {
        path: '/test/:testid',
        name: 'test-edit',
        component: TestEdit
    },
    {
        path: '/profile',
        name: 'user-profile',
        component: UserProfile
    },
    {
        path: '/reset/password',
        name: 'password-reset',
        component: PasswordReset
    },
    {
        path: '/source',
        name: 'source',
        component: Source
    }
]

const router = createRouter({history: createWebHistory(process.env.VUE_APP_PUBLIC_PATH), routes});

export default router
